import configFR from '../config/FR';
import configGB from '../config/GB';
import configINT from '../config/INT';
import configUS from '../config/US';

import getConfigurationCountry from './getConfigurationCountry';

import type {
  LocalisationConfig,
  LocalisationConfigWithLang,
  LocalisationConfigEntry,
  LocalisationConfigValue,
  LocalisationConfigContextType,
} from '../types';

let config: LocalisationConfig = {};

export function resolveConfigLanguage(newConfig: LocalisationConfigWithLang, language: string) {
  const langResolvedConfig = { ...newConfig } as LocalisationConfig;

  Object.entries(langResolvedConfig).forEach(([key, value]) => {
    const resolvedValue =
      typeof value === 'object' && !Array.isArray(value) ? value[language] ?? value.en : value;

    langResolvedConfig[key as LocalisationConfigEntry] = resolvedValue;
  });

  return langResolvedConfig;
}

export function setconfigByCountry(country: string, language: string) {
  let newConfig: LocalisationConfigWithLang;

  switch (getConfigurationCountry(country)) {
    case 'FR':
      newConfig = configFR;
      break;
    case 'GB':
      newConfig = configGB;
      break;
    case 'US':
      newConfig = configUS;
      break;
    default:
      newConfig = configINT;
      break;
  }
  const langResolvedConfig = resolveConfigLanguage(newConfig, language);

  config = langResolvedConfig as LocalisationConfig;

  return config;
}

export function getConfig(): LocalisationConfig {
  return config;
}

export function setConfig(newConfig: LocalisationConfig) {
  config = newConfig;
}

export function createLocalisationConfigContext(configuration: LocalisationConfig) {
  const context: LocalisationConfigContextType = {
    configuration,
    getLocalisationConfig: (name: LocalisationConfigEntry) =>
      configuration[name] as LocalisationConfigValue,
  };

  return context;
}
